import { CurrencyPipe, PercentPipe } from '@angular/common';
import { Column, GridRow } from '@shared';

class DeliveryException {
  @Column({
    title: 'Type',
    field: 'itemType',
    order: 0.2,
    width: 80,
    filterable: true,
    filterType: 'text',
    type: 'string',
    sortable: true,
    align: 'left',
  })
  itemType?: string;

  @Column({
    title: 'Restaurant',
    field: 'restaurantName',
    order: 0.1,
    width: 100,
    filterable: true,
    filterType: 'text',
    type: 'string',
    sortable: true,
    align: 'left',
  })
  restaurantName?: string;

  @Column({
    title: 'Tier',
    field: 'tierName',
    order: 0,
    width: 80,
    filterable: true,
    filterType: 'text',
    type: 'string',
    sortable: true,
    align: 'left',
  })
  tierName?: string;
  @Column({
    title: 'Brink ID',
    field: 'parItemId',
    order: 0.7,
    width: 90,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    sortable: true,
  })
  parItemId?: number;

  @Column({
    field: 'plu',
    title: 'PLU',
    order: 1.9,
    width: 60,
    filterable: true,
    filterType: 'text',
    type: 'string',
    sortable: true,
    visibleInQuickView: true,
  })
  plu?: string;

  @Column({
    title: 'Is Active',
    field: 'isActive',
    order: 0.7,
    width: 80,
    filterable: true,
    filterType: 'boolean',
    type: 'boolean',
    fixed: true,
    sortable: true,
    filterOptions: [
      { name: 'Available', value: true },
      { name: 'Not Available', value: false },
    ],
  })
  isActive?: boolean;

  @Column({
    title: 'Product',
    field: 'itemName',
    order: 0.6,
    width: 150,
    filterable: true,
    filterType: 'text',
    type: 'string',
    fixed: true,
    align: 'left',
    sortable: true,
    visibleInQuickView: true,
  })
  itemName?: string;

  @Column({
    field: 'itemPrice',
    title: 'Current Price',
    order: 3,
    pipeToken: CurrencyPipe,
    width: 80,
    filterable: true,
    filterType: 'numeric',
    sortable: true,
    visibleInQuickView: true,
  })
  itemPrice?: number;

  @Column({
    field: 'deliveryPrice',
    title: 'Delivery Price',
    order: 10,
    pipeToken: CurrencyPipe,
    width: 80,
    filterType: 'numeric',
    filterable: true,
    sortable: true,
    visibleInQuickView: true,
  })
  deliveryPrice?: number;

  @Column({
    field: 'deliveryUpchargePercentage',
    title: 'Delivery Upcharge %',
    order: 11,
    pipeToken: PercentPipe,
    filterable: true,
    filterType: 'percentage',
    sortable: true,
    width: 90,
  })
  deliveryUpchargePercentage?: number;

  constructor(
    parItemId?: number,
    plu?: string,
    itemName?: string,
    itemPrice?: number,
    deliveryPrice?: number,
    deliveryUpchargePercentage?: number,
    restaurantName?: string,
    tierName?: string,
    itemType?: string,
    isActive?: boolean,
  ) {
    this.parItemId = parItemId;
    this.plu = plu;
    this.itemName = itemName;
    this.itemPrice = itemPrice;
    this.deliveryPrice = deliveryPrice;
    this.deliveryUpchargePercentage = deliveryUpchargePercentage;
    this.restaurantName = restaurantName;
    this.tierName = tierName;
    this.itemType = itemType;
    this.isActive = isActive;
  }
}

export class GridRowDeliveryException extends GridRow(DeliveryException) {}
